/**
 * File Input Stage
 *
 * Handles raw telemetry input from file loading (as opposed to DTO from backend).
 * This stage is used when processing device files directly rather than loading from API.
 */

import {
  PipelineStage,
  PipelineContext,
  StageResult,
} from '../ProcessingPipeline'
import { RawTelemetryData } from '../../../domain/telemetry/raw/RawTelemetryData'

export class FileInputStage implements PipelineStage {
  name = 'File Input'

  constructor(private rawTelemetry: RawTelemetryData) {}

  async execute(context: PipelineContext): Promise<StageResult<void>> {
    const warnings: string[] = []

    try {
      // Validate raw telemetry has GPS data
      if (!this.rawTelemetry.gps || this.rawTelemetry.gps.length === 0) {
        return {
          success: false,
          error: 'No GPS data available in raw telemetry',
        }
      }

      // Check for optional sensor data
      if (
        !this.rawTelemetry.gyroscope ||
        this.rawTelemetry.gyroscope.length === 0
      ) {
        warnings.push(
          'No gyroscope data available - lean angle will be calculated from GPS'
        )
      }

      if (
        !this.rawTelemetry.accelerometer ||
        this.rawTelemetry.accelerometer.length === 0
      ) {
        warnings.push(
          'No accelerometer data available - acceleration will be calculated from GPS'
        )
      }

      // Set raw telemetry on context
      context.rawTelemetry = this.rawTelemetry

      return {
        success: true,
        warnings: warnings.length > 0 ? warnings : undefined,
      }
    } catch (error) {
      return {
        success: false,
        error: `File input failed: ${error instanceof Error ? error.message : String(error)}`,
      }
    }
  }
}
